import { HttpInterceptorFn } from '@angular/common/http';

const HEADER = 'X-Correlation-Id';

/**
 * Stamps every outbound request with an `X-Correlation-Id` header so we
 * can trace a single user action through the Angular client and the .NET
 * backend logs.
 */
export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  // Don't override an id set upstream (e.g. by a retry).
  if (req.headers.has(HEADER)) {
    return next(req);
  }
  const id = generateCorrelationId();
  return next(req.clone({ setHeaders: { [HEADER]: id } }));
};

function generateCorrelationId(): string {
  // Prefer the platform crypto uuid where available (Node 19+, modern browsers).
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  // Fallback — sufficient for a correlation id, not for security.
  const rand = () => Math.random().toString(16).slice(2, 10);
  return `${rand()}-${rand()}-${rand()}-${rand()}`;
}
